export const getId = (targetIndex)=>{
    return window.location?.pathname?.split('/')?.[targetIndex]

}